import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';

import { MenuPanelComponent } from '../menu-panel/menu-panel.component';
import { MenuPanelItemModel } from '../menu-panel/menu-panel-item.model';
import { MenuSelectItemModel } from './menu-select-item.model';

@Component({
  selector: 'rnpl-menu-select',
  templateUrl: './menu-select.component.html',
  styleUrls: ['./menu-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuSelectComponent implements OnChanges {

  @Input() items: MenuSelectItemModel[] = [];
  @Input() value: string = null;
  @Input() placeholder: string = null;
  @Input() label: string = null;

  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild('triggerEl', { static: true }) private triggerEl: ElementRef<HTMLElement>;
  @ViewChild('panel', { static: false }) private panel: MenuPanelComponent;

  public panelItems: MenuPanelItemModel[] = [];
  public isOpen = false;

  public get selectedLabel(): string {
    const selected = this.items.find(item => item.id === this.value);
    return selected ? selected.label : null;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && (changes.hasOwnProperty('items') || changes.hasOwnProperty('value'))) {
      this.buildPanelItems();
    }
  }

  public toggle(): void {
    if (this.isOpen) {
      if (this.panel) { this.panel.close(); }
      return;
    }

    if (!this.items.length) { return; }

    this.buildPanelItems();

    if (this.panel && this.triggerEl) {
      this.isOpen = true;
      this.panel.open(this.triggerEl.nativeElement);
    }
  }

  public onPanelClosed(): void {
    this.isOpen = false;
  }

  public onPanelItemSelected(item: MenuPanelItemModel): void {
    if (!item) { return; }
    this.valueChange.emit(item.id);
  }

  private buildPanelItems(): void {
    this.panelItems = this.items.map(item => ({
      id: item.id,
      label: item.label,
      checked: item.id === this.value,
    }));
  }
}
